import { html } from '../common/html';

/**
 * おもてなしコンテンツ®のHTMLマークアップ
 */
export const OmotenashiContentsHtml = html`
  <div class="omotenashi-contents">
    <h2 class="omotenashi-contents-ttl ttl2 c1 tc">&mdash;</h2>
    <div class="omotenashi-contents-inner">
      <div class="omotenashi-contents-access">
        <div class="omotenashi-contents-access-inner"><img src="/omotenashi-contents/access/00.svg" alt="&mdash;" /></div>
      </div>
      <div class="omotenashi-contents-weather">
        <div class="omotenashi-contents-weather-place">
          <table class="omotenashi-contents-weather-table">
            <tr class="weather-date-dow">
              <th>&emsp;</th>
              <th>
                <div class="date -first">&mdash;/&mdash;</div>
                <div class="dow">(&mdash;)</div>
              </th>
              <th>
                <div class="date">&mdash;/&mdash;</div>
                <div class="dow">(&mdash;)</div>
              </th>
              <th>
                <div class="date">&mdash;/&mdash;</div>
                <div class="dow">(&mdash;)</div>
              </th>
            </tr>
            <tr class="weather-icon-temp">
              <th class="place-name">&mdash;</th>
              <td>
                <div class="icon"><img src="/omotenashi-contents/weather/00.png" alt="&mdash;" /></div>
                <div class="temp"><span class="temp-min">&mdash;&#8451;</span><span class="temp-sep">/</span><span class="temp-max">&mdash;&#8451;</span></div>
              </td>
              <td>
                <div class="icon"><img src="/omotenashi-contents/weather/00.png" alt="&mdash;" /></div>
                <div class="temp"><span class="temp-min">&mdash;&#8451;</span><span class="temp-sep">/</span><span class="temp-max">&mdash;&#8451;</span></div>
              </td>
              <td>
                <div class="icon"><img src="/omotenashi-contents/weather/00.png" alt="&mdash;" /></div>
                <div class="temp"><span class="temp-min">&mdash;&#8451;</span><span class="temp-sep">/</span><span class="temp-max">&mdash;&#8451;</span></div>
              </td>
            </tr>
          </table>
        </div>
        <div class="omotenashi-contents-weather-from">
          <table class="omotenashi-contents-weather-table">
            <tr class="weather-date-dow">
              <th>&emsp;</th>
              <th>
                <div class="date -first">&mdash;/&mdash;</div>
                <div class="dow">(&mdash;)</div>
              </th>
              <th>
                <div class="date">&mdash;/&mdash;</div>
                <div class="dow">(&mdash;)</div>
              </th>
              <th>
                <div class="date">&mdash;/&mdash;</div>
                <div class="dow">(&mdash;)</div>
              </th>
            </tr>
            <tr class="weather-icon-temp">
              <th class="from-name">&mdash;</th>
              <td>
                <div class="icon"><img src="/omotenashi-contents/weather/00.png" alt="&mdash;" /></div>
                <div class="temp"><span class="temp-min">&mdash;&#8451;</span><span class="temp-sep">/</span><span class="temp-max">&mdash;&#8451;</span></div>
              </td>
              <td>
                <div class="icon"><img src="/omotenashi-contents/weather/00.png" alt="&mdash;" /></div>
                <div class="temp"><span class="temp-min">&mdash;&#8451;</span><span class="temp-sep">/</span><span class="temp-max">&mdash;&#8451;</span></div>
              </td>
              <td>
                <div class="icon"><img src="/omotenashi-contents/weather/00.png" alt="&mdash;" /></div>
                <div class="temp"><span class="temp-min">&mdash;&#8451;</span><span class="temp-sep">/</span><span class="temp-max">&mdash;&#8451;</span></div>
              </td>
            </tr>
          </table>
        </div>
        <div class="omotenashi-contents-update">&mdash;</div>
        <div class="omotenashi-contents-copyright">&copy; Craid &amp; Yuka Natsumi</div>
      </div>
    </div>
  </div>
`;
